import axios from 'axios'
import store from '@/store'
import router from '@/router'
import { redirectToLogin } from '@/services/auth-redirect'

import AppActions from '@/store/app/actions-types'
import AuthActions from '@/store/core/auth/actions-types'
import { applyScopedToken, isScopedTokenRoute } from '@/services/scoped-token'

let config = {
  baseURL: process.env.VUE_APP_CORE_API_URL,
  headers: {
    'Content-Type': 'application/json'
  }
}

const AxiosCore = axios.create(config)

AxiosCore.interceptors.request.use(
  function(config) {
    if (applyScopedToken(config, router.currentRoute)) {
      return config
    }

    if (store.state.core.auth.token) {
      config.headers.common['token'] = store.state.core.auth.token
    }

    return config;
  },
  function(error) {
    return Promise.reject(error);
  }
);

AxiosCore.interceptors.response.use(
  function(response) {
    return response;
  },
  function(error) {
    if (isScopedTokenRoute(router.currentRoute)) {
      return Promise.reject(error)
    }

    if (error.response) {
      if (error.response.status == 403) {
        router.push('/')
      }

      if (error.response.status == 401 && store.state.core.auth.authenticated) {
        store
          .dispatch('core/auth/' + AuthActions.DO_LOGOUT)
          .then(() => {
            redirectToLogin()
          })
      }

      if (error.response.data.message) {
        store.dispatch('app/' + AppActions.OPEN_APP_ERROR_MESSAGE, error.response.data.message)
      }
    }

    return Promise.reject(error)
  }
)

export default AxiosCore
